// ======================================================================
// File Name       : ParticipantListContainer
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React, { Component } from 'react';
import moment from 'moment';
import { Field, reduxForm, isInvalid, getFormValues, submit } from 'redux-form';
import { connect } from 'react-redux';
import { Button } from 'react-bootstrap';
import Header from '../../../components/Header';
import ParticipantSearch from '../../../components/userHistory/participant/ParticipantSearch';
import ParticipantList from '../../../components/userHistory/participant/ParticipantList';
import * as GroupAction from '../../../actions/GroupAction';
import * as userActions from '../../../actions/UserAction';
import ModalConductor from '../../../components/modal/ModalConductor';
import * as ModalIds from '../../../constants/ModalIds';
import * as ModalAction from '../../../actions/ModalAction';
import * as ParticipantAction from '../../../actions/ParticipantAction';
import { RETURN_MAX_NUM } from '../../../constants/index';
import { USER_TYPE } from '../../../constants/UserConstants';
import { PARTICIPANT_LIST, PARTICIPANT_DETAIL } from '../../../constants/PathConstants';
import MessageSearch from '../../../components/MessageSearch';
import { isSuperUser } from '../../../utils/index';
import * as actionType from '../../../constants/actionTypes/page';

class ParticipantListContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      filterData: {},
      isAllowShowSearchMessage: false,
      isInit: true,
    };
    this.initData = this.initData.bind(this);
    this.selectGroup = this.selectGroup.bind(this);
    this.removeSelectedGroup = this.removeSelectedGroup.bind(this);
    this.getStartEndData = this.getStartEndData.bind(this);
    this.searchData = this.searchData.bind(this);
    this.handleSortState = this.handleSortState.bind(this);
    this.createParams = this.createParams.bind(this);
    this.clickSearchButton = this.clickSearchButton.bind(this);
    this.goToDetail = this.goToDetail.bind(this);
    this.dismissMessage = this.dismissMessage.bind(this);
    this.handleMouseEnter = this.handleMouseEnter.bind(this);
    this.handleMouseLeave = this.handleMouseLeave.bind(this);
  }
  componentWillMount() {
    const { searchCondition } = this.props;
    const filterData = {
      ...this.state,
      filterData: searchCondition,
    };
    this.setState(
      filterData,
    );
    this.initData();
  }

  componentWillUnmount() {
    const { formValues } = this.props;
    this.props.dispatch(GroupAction.removeSelectedGroup());
    this.props.dispatch({
      type: actionType.SAVE_SEARCH_CONDITION,
      parentPath: PARTICIPANT_LIST,
      searchCondition: formValues,
    });
  }

  goToDetail(userSecernId) {
    const { invalid, formValues } = this.props;
    if (!invalid) {
      this.props.dispatch({
        type: actionType.SAVE_SEARCH_CONDITION,
        parentPath: PARTICIPANT_LIST,
        searchCondition: formValues,
      });
    }
    const path = PARTICIPANT_DETAIL.replace(':id', userSecernId);
    this.props.history.push(path);
  }

  getStartEndData(startPosition) {
    const { invalid, formValues } = this.props;
    if (invalid) return;
    let column = null;
    if (formValues.userSortType) {
      column = formValues.userSortType;
    }
    this.searchData(startPosition, column);
  }

  handleSortState(column) {
    const { invalid, formValues } = this.props;
    if (invalid) return;
    let startPosition = 0;
    if (formValues.startPosition) {
      startPosition = formValues.startPosition;
    }
    this.searchData(startPosition, column);
  }

  searchData(startPosition, column) {
    const { filterData } = this.state;
    const { invalid, dispatch, formValues } = this.props;
    if (invalid) {
      return;
    }
    const paramSearch = this.createParams(filterData, column, startPosition);
    this.props.dispatch(ParticipantAction.searchParticipant(paramSearch))
    .then(() => {
      this.setState({ isAllowShowSearchMessage: true });
    });
  }

  createParams(data, column, startPosition) {
    const param = { ...data };
    if (!isNaN(parseInt(startPosition, 10))) {
      param.startPosition = startPosition;
    }
    if (column && Object.keys(column).length) {
      param.ascendingDescendingSort = column.sortState;
      param.userSortType = column.sortBy;
    }

    if (!column) {
      param.ascendingDescendingSort = null;
      param.userSortType = null;
    }

    param.returnMaxNum = RETURN_MAX_NUM;
    param.userType = USER_TYPE.STUDENT;
    if (data.selectedTargetGroup && data.selectedTargetGroup.groupSecernId) {
      param.groupList = [data.selectedTargetGroup.groupSecernId];
    }
    return param;
  }

  clickSearchButton() {
    const { dispatch, formValues, invalid } = this.props;
    if (invalid) {
      return;
    }
    let groupList = [];
    if (formValues.selectedTargetGroup && formValues.selectedTargetGroup.groupSecernId) {
      const groupSecernId = formValues.selectedTargetGroup.groupSecernId;
      groupList = [groupSecernId];
    }
    const filterData = {
      startPosition: formValues.startPosition,
      userSortType: formValues.userSortType,
      ascendingDescendingSort: formValues.ascendingDescendingSort,
      userName: formValues.userName,
      groupList,
    };
    this.setState({ filterData }, () => {
      const paramSearch = this.createParams(filterData, null, 0);
      this.props.change('startPosition', 0);
      this.props.change('userSortType', null);
      this.props.change('ascendingDescendingSort', null);
      this.props.dispatch(ParticipantAction.searchParticipant(paramSearch))
      .then(() => {
        this.setState({ isAllowShowSearchMessage: true });
      });
    });
  }

  initData() {
    const { initialValues } = this.props;
    let column = null;
    let startPosition = 0;
    if (initialValues) {
      if (initialValues.userSortType) {
        column = initialValues.userSortType;
      }
      if (initialValues.startPosition) {
        startPosition = initialValues.startPosition;
      }
    }
    const param = this.createParams(initialValues, column, startPosition);
    this.props.dispatch(ParticipantAction.searchParticipant(param));
  }

  removeSelectedGroup() {
    this.props.dispatch(GroupAction.removeSelectedGroup());
    this.props.change('selectedTargetGroup', '');
    this.props.dispatch({
      type: actionType.CLEAR_SEARCH_CONDITION,
    });
  }

  selectGroup() {
    const { dispatch } = this.props;
    dispatch(ModalAction.openModal(ModalIds.SELECT_GROUP_MODAL_PARTICIPANT));
  }

  dismissMessage() {
    this.setState({ isAllowShowSearchMessage: false });
  }

  handleMouseEnter(index) {
    this.setState({
      hoverIndex: index,
    });
  }

  handleMouseLeave() {
    this.setState({
      hoverIndex: undefined,
    });
  }

  render() {
    const { groupList, invalid, selectedTargetGroup, participant, searchCondition } = this.props;
    const { hoverIndex } = this.state;
    return (
      <div>
        <MessageSearch
          recordNum={participant.userListDialogRecordNum}
          resultList={participant ? participant.userList : []}
          isAllowShowSearchMessage={this.state.isAllowShowSearchMessage}
          dismissMessage={this.dismissMessage}
        />
        <ParticipantSearch
          groupList={groupList}
          selectGroup={this.selectGroup}
          selectedTargetGroup={selectedTargetGroup}
          removeSelectedGroup={this.removeSelectedGroup}
          invalid={invalid}
          clickSearchButton={this.clickSearchButton}
          searchCondition={searchCondition}
        />
        <ParticipantList
          participant={participant}
          handleSortState={this.handleSortState}
          goToDetail={this.goToDetail}
          recordNum={participant.userListDialogRecordNum}
          getStartEndData={this.getStartEndData}
          hoverIndex={hoverIndex}
          handleMouseEnter={this.handleMouseEnter}
          handleMouseLeave={this.handleMouseLeave}
        />
        <ModalConductor
          history={this.props.history}
          treeCheckBox={false}
          formKey="participantList"
        />
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { groupList, selectedTargetGroup } = state.group;
  const { parentPath, searchCondition } = state.page;
  const participant = state.participant;
  const { authedUser } = state.authed;
  let initial = {};
  if (parentPath === PARTICIPANT_LIST) {
    if (searchCondition) {
      const paramSearch = {};
      paramSearch.userName = searchCondition.userName;
      paramSearch.selectedTargetGroup = searchCondition.selectedTargetGroup;
      paramSearch.userSortType = searchCondition.userSortType;
      paramSearch.ascendingDescendingSort = searchCondition.ascendingDescendingSort;
      paramSearch.startPosition = searchCondition.startPosition;
      initial = paramSearch;
    }
  }
  const invalid = isInvalid('participantList')(state);
  return {
    initialValues: initial,
    groupList,
    selectedTargetGroup,
    participant,
    invalid,
    formValues: getFormValues('participantList')(state),
    searchCondition,
    authedUser,
  };
};

export default connect(mapStateToProps)(reduxForm({
  form: 'participantList', // a unique identifier for this form
  touchOnChange: true,
})(ParticipantListContainer));
